import { FrontendApplication, FrontendApplicationContribution, WidgetManager } from '@theia/core/lib/browser';
import { Widget } from '@theia/core/lib/browser/widgets/widget';
import { inject, injectable } from '@theia/core/shared/inversify';
import { LicenseOverlayHostWidget } from './license-overlay-host-widget';

@injectable()
export class LicenseOverlayHostContribution implements FrontendApplicationContribution {
    @inject(WidgetManager)
    protected readonly widgetManager!: WidgetManager;

    async onStart(_app: FrontendApplication): Promise<void> {
        const widget: LicenseOverlayHostWidget = await this.widgetManager.getOrCreateWidget(
            LicenseOverlayHostWidget.ID
        );
        if (!widget.isAttached) {
            Widget.attach(widget, document.body);
        }
    }
}
